
<div
  id="sticky-button"
  :class="[
    `w-full fixed left-0 p-16 border-t-1 border-solid border-grey-divider-subdued bg-foreground`,
    variantStyles,
    pageHasBottomNav ? 'bottom-80' : 'bottom-0',
  ]"
>
  <Button
    :value="value"
    size="medium"
    class="w-full"
    :variant="btnVariant"
    :to="to"
    :href="href"
    :loading="loading"
    @click="clickHandler"
  />
</div>
